/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Refund_TitleInputs */

const vi_customer_refund_title = /** @type {(inputs: Customer_Refund_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn tiền cho khách`)
};

/**

* @param {Customer_Refund_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_refund_title = /** @type {((inputs?: Customer_Refund_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Refund_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_refund_title(inputs)
});